export default "__VITE_ASSET__C3qB0wNo__"